import { cssToken } from "@/lib/cssToken";

export const SKELETON_BAR_WIDTH = 3;
export const SKELETON_BAR_GAP = 2;
export const SKELETON_BAR_MIN_HEIGHT = 3;
export const SKELETON_HEIGHT = 38;

/** Resolved at call time so dark theme updates are picked up. */
export function skeletonWaveColor(): string {
    return cssToken("--color-neutral-text-400", "#d7d5d2");
}

export function skeletonUnloadedColor(): string {
    return cssToken("--color-neutral-border-300", "#e7e7e7");
}

// Back-compat constants for existing imports — prefer the functions above.
export const SKELETON_WAVE_COLOR = "#d7d5d2ff";
export const SKELETON_UNLOADED_COLOR = "#eceae7";

function hashString(value: string): number {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
    }
    return hash;
}

export function generateSkeletonBarHeights(seed: string, count: number): number[] {
    if (count <= 0) return [];
    let state = hashString(seed);
    const heights: number[] = [];
    for (let i = 0; i < count; i++) {
        state = (state * 1664525 + 1013904223) >>> 0;
        const ratio = (state % 1000) / 1000;
        heights.push(
            SKELETON_BAR_MIN_HEIGHT + ratio * (SKELETON_HEIGHT - SKELETON_BAR_MIN_HEIGHT),
        );
    }
    return heights;
}

export function getSkeletonBarLoadedStates(
    barCount: number,
    bufferPercent: number,
): boolean[] {
    return Array.from({ length: barCount }, (_, index) =>
        barCount > 0 && (index / barCount) * 100 < bufferPercent,
    );
}

export const DECORATIVE_PEAK_COUNT = 384;

export function generateDecorativePeaks(
    seed: string,
    count = DECORATIVE_PEAK_COUNT,
): number[][] {
    const heights = generateSkeletonBarHeights(seed, count);
    const channel = heights.map((h) => {
        const ratio =
            (h - SKELETON_BAR_MIN_HEIGHT) /
            (SKELETON_HEIGHT - SKELETON_BAR_MIN_HEIGHT);
        return ratio * 0.85;
    });
    return [channel];
}
